import React, { FC, useEffect } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import { Icon } from '../icons/icons';
import { ISkillLevel } from '../../model/SkillLevel.model';
import { ISkill } from '../../model/Skill.model';
import { ISkillGroup } from '../../model/SkillGroup.model';
import { Link } from 'react-router-dom';
import "./SkillDivider.scss";

const gettooltipContent = (description: string) => {
   return <>
      <div className="dis-flex dis-flx-aln-center gap--50">
         <Icon name="icon-info" className='tooltip-icon icon-med-gray core-tooltip-content-icon' />
         <span className='fnt-wght-700'>Skill Definition</span>
      </div>
      <p className='m-t--75 m-b-0 fnt-wght-400'>{description}</p>
   </>
};/* temp until we get it from the DB */

interface SkillDividerProps {
   dividerClassNames: Array<string>,
   headingLevel: number,
   skillLevels: ISkillLevel[] | undefined,
   headingClassNames: Array<string>,
   dividerText: string,
   tooltipContent: string;
   backgroundColor?: string;
   skillPathId?: number;
   isBookmarksSkillDivider?: boolean
}


const SkillDivider: FC<SkillDividerProps> = ({ dividerClassNames, headingLevel, skillLevels, headingClassNames, dividerText, tooltipContent, backgroundColor, skillPathId, isBookmarksSkillDivider = false }) => {
   const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;
   const [aryIconClasses] = React.useState(['tooltip-icon']);
   const [aryLinkBgClasses] = React.useState(['btn-outlined-primary-sml', 'skill-divider-link-button']);
   const [textColor, setTextColor] = React.useState<string>("");
   const [linkButtonHoverBgColor, setLinkButtonHoverBgColor] = React.useState<string>("");
   const sklPathId = skillPathId;
   const isBookmarksPage = isBookmarksSkillDivider;


   useEffect(() => {
      setIconColorClasses();
   }, [aryIconClasses]);

   useEffect(() => {
      if (backgroundColor === "#fed103") {
         setTextColor("#000000");
      } else {
         setTextColor("#ffffff");
      }
   }, [textColor]);

   useEffect(() => {
      aryLinkBgClasses.push("sklpthid" + skillPathId);
   }, [aryLinkBgClasses]);

   const setIconColorClasses = () => {
      if (backgroundColor === "#fed103") {
         aryIconClasses.push('icon-black')
      } else {
         aryIconClasses.push('icon-white')
      }
   }

   return (
      <div className={dividerClassNames.join(' ')} style={{ backgroundColor: backgroundColor }}>
         {isBookmarksPage && (
            <Link className={aryLinkBgClasses.join(' ')} style={{ display: "none", color: textColor, borderColor: textColor, fontWeight: 500 }} to={"/skillpath/" + sklPathId + "?showAll=true"} target='_blank'>View Skill</Link>
         )}
         {!isBookmarksPage && (
            <>&nbsp;</>
         )}
         <HeadingTag className={headingClassNames.join(' ')}>
            <span style={{ color: textColor }}>{dividerText}</span>
         </HeadingTag>
         <Tooltip content={gettooltipContent(tooltipContent)}>
            <Icon name="icon-info" className={aryIconClasses.join(' ')} />
         </Tooltip>
      </div>
   )
};

export default SkillDivider;
